import ValueTrackerObjGen from "../../prop-tracker-utils/value-tracker-obj-gen.js";

import CurrentSlideMux from "./trackers/current-slide/current-slide-mux.js";

class CurrentSlide {
    constructor(wrapCtx, evtCtx) {
        this._slideMux = new CurrentSlideMux(evtCtx);
        this._slideGen = new ValueTrackerObjGen(wrapCtx, evtCtx, this._slideMux);
    }

    get slide() { return this._slideGen; }

    track(tour, tourEvents, session, sessionEvents) {
        this._slideMux.trackTour(tour, tourEvents);
        this._slideMux.trackSession(session, sessionEvents);
    }

    update() {
        this._slideGen.update();
    }
}

export default CurrentSlide;
